import { Popover, Tooltip } from "bootstrap";

const Utilities = () => {
    const returnObj = {};

    /** Mainnavigation dropdown placement fix */
    returnObj.initNavigationFix = function () {
        jQuery('nav.mainnav ul li').each(function (i, el) {
            if (jQuery(el).hasClass('dropdown')) {
                var menuOffLeft = jQuery(el).offset().left;
                var ddMenuWidth = jQuery(el).children('.dropdown-menu').outerWidth();
                var elPos = (ddMenuWidth + menuOffLeft);

                if (elPos >= jQuery(window).width()) {
                    jQuery(el).children('.dropdown-menu').css({
                        left: 'auto',
                        right: 0
                    });
                }
            }
        });
    };

    /**
     * function fix for dropdown menu
     * if the menu dropdown is over the window viewport
     * is change the css to set it in
     */
    returnObj.dropdownFix = function () {
        jQuery('[data-bs-toggle="dropdown"]').parent().on("shown.bs.dropdown", function () {
            var $dropMenu = jQuery(this).children('.dropdown-menu');
            var dropMenuWidth = $dropMenu.outerWidth();
            var posLeft = $dropMenu.offset().left;
            var containerWidth = jQuery('.container-fluid').width();

            var calc = containerWidth - posLeft;

            if (calc < dropMenuWidth) {
                $dropMenu.css({ 'left': 'auto', 'right': '0' });
            }
        });
    };

    /**
     * this is find the hightest element
     *
     * this function is needed the jquery-actual js-lib
     */
    returnObj.highestChildren = function (hash, returnSize) {
        returnSize = returnSize || false;
        let itemH = 0;
        let highestItem;
        jQuery(hash).each(function () {
            const tempHeight = jQuery(this).outerHeight();
            if (tempHeight > itemH) {
                highestItem = this;
                itemH = tempHeight;
            }
        });

        if (returnSize) {
            return jQuery(highestItem).outerHeight();
        } else {
            return highestItem;
        }
    };

    /**
     * Auto calc and rendering the same height on row
     */
    returnObj.equalHeight = function ($selector, type, all, remove, removeChilds) {
        if (!$selector) {
            $selector = jQuery(document);
        } else if (!($selector instanceof $)) {
            $selector = jQuery($selector);
        }
        if ($selector.length === 0) {
            //console.debug('ERROR: Please set a selector to equalHeight.');
            return false;
        }
        type = ' ' + type || '';
        remove = remove || false;
        removeChilds = removeChilds || false;
        all = all || false;

        $selector.each(function (i, el) {
            const $el = jQuery(el),
                $parentEl = $el.closest('div.row, div.setu_econda'),
                elementTypes = $el.find(type);
            if (remove) {
                elementTypes.each((index, element) => {
                    element.style.height = null;
                });
            }
            if (removeChilds) {
                elementTypes.find('[style]').not('.intrinsic').each((index, element) => {
                    element.style.height = null;
                });
            }
            elementTypes.responsiveEqualHeightGrid(all);
        });
    };

    /**
     * generate the Tooltip and Popover events after
     * the table is loaded
     * @param current
     */
    returnObj.tooltipEventOnTableCell = function (current) {
        jQuery(current).find('.jsLoadPopOver, .jsLoadToolTip').each(function (i, e) {
            if (jQuery(e).hasClass('jsLoadPopOver')) {
                Popover.getOrCreateInstance(e, { html: true });
            }
            if (jQuery(e).hasClass('jsLoadToolTip')) {
                Tooltip.getOrCreateInstance(e, { html: true });
            }
        });

        /**
         * set the tooltip / popover event pack to new loaded.
         */
        jQuery(current).on('click', '.jsLoadPopOver[data-setu-trigger-fix="focus"], .jsLoadToolTip[data-setu-trigger-fix="focus"]', function (e) {
            if (jQuery(e.currentTarget).hasClass('jsLoadPopOver')) {
                jQuery('.jsLoadTable .jsLoadPopOver[data-setu-trigger-fix="focus"][aria-describedby]')
                    .not(jQuery(e.currentTarget))
                    .each(
                        (index, element) => bootstrap.Popover.getOrCreateInstance(element).dispose()
                    );
            }
        });
    };

    returnObj.equalHeightRowFix = function (hash, fixHash) {
        jQuery(hash).parent('.row').addClass(fixHash)
    };


    // fixing the hover event at the same row
    returnObj.mouseEventFixedColumns = function ($tables) {
        $tables.find('tr')
            .mouseenter(function () {
                $tables.find('tr').removeClass('hover');
                $tables.find('tr[data-index="' + jQuery(this).attr('data-index') + '"]').addClass('hover');
            })
            .mouseleave(function () {
                $tables.find('tr').removeClass('hover');
            });
    };


    /**
     * jQuery plug-in add-on to remove all html-attributes
     */
    jQuery.fn.removeAllAttr = function () {
        return this.each(function () {
            var attributes = jQuery.map(this.attributes, function (item) {
                return item.name;
            });
            var img = $(this);
            jQuery.each(attributes, function (i, item) {
                img.removeAttr(item);
            });
        });
    };


    /**
     * initial loading
     */
    returnObj.init = function () {

        /** initial variables */
        returnObj.jsScreenSMmin = parseFloat(jQuery('.js-screen-sm-min-max').css('min-width'));
        returnObj.jsScreenSMmax = parseFloat(jQuery('.js-screen-sm-min-max').css('max-width'));

        returnObj.initNavigationFix();
        returnObj.dropdownFix();
    };

    return returnObj;
};

export const utilities = Utilities();
